import React from 'react';
import { IconButton, Grid, Tooltip } from '@mui/material';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { useLang } from '~/hooks/useLang';
import useSystemState from '~/features/System/stores/SystemState';

interface RegistrationButtonProps {
  readonly canAddRegistration?: boolean
}

export default function RegistrationButton({ canAddRegistration }: RegistrationButtonProps) {
  const { translate } = useLang();
  const { windowManager } = useSystemState();

  const handleClickOpen = () => {
    windowManager()['registration'].open.set(!windowManager()['registration'].open.get());
  };

  return (
    <Grid item>
      <Tooltip
        placement="right-start"
        title={translate('Registration of Qualifiers')}
        componentsProps={{ tooltip: { sx: { fontSize: '14px', padding: '6px 10px' } } }}
      >
        <span style={{ display: 'inline-block' }}>
          <IconButton
            disabled={!canAddRegistration}
            onClick={handleClickOpen}
          >
            <PeopleAltIcon fontSize='small' />
          </IconButton>
        </span>
      </Tooltip>
    </Grid>);

}
